// Minimal top-of-page loading bar (replaces the abandoned nprogress package).
// API mirrors nprogress: progressBar.start() / progressBar.done().
let bar = null
let trickleTimer = null
let progress = 0

function ensureBar() {
    if (bar) return bar
    bar = document.createElement('div')
    bar.className = 'lc-progress-bar'
    bar.style.cssText = [
        'position:fixed',
        'top:0',
        'left:0',
        'height:3px',
        'width:0',
        'z-index:9999',
        'background:#5265e8',
        'box-shadow:0 0 8px rgba(82,101,232,0.6)',
        'opacity:0',
        'transition:width 0.2s ease, opacity 0.3s ease',
        'pointer-events:none',
    ].join(';')
    document.body.appendChild(bar)
    return bar
}

function set(value) {
    progress = value
    const el = ensureBar()
    el.style.opacity = '1'
    el.style.width = `${value}%`
}

function start() {
    if (trickleTimer) clearInterval(trickleTimer)
    set(8)
    // trickle towards 90% so the bar keeps moving while the route loads
    trickleTimer = setInterval(() => {
        if (progress >= 90) return
        set(progress + (90 - progress) * 0.1)
    }, 300)
}

function done() {
    if (trickleTimer) {
        clearInterval(trickleTimer)
        trickleTimer = null
    }
    if (!bar) return
    set(100)
    setTimeout(() => {
        bar.style.opacity = '0'
        setTimeout(() => {
            bar.style.width = '0'
            progress = 0
        }, 300)
    }, 200)
}

export default { start, done }
